export enum VehicleRegisterType {
  VIN,
  REPUVE,
  LicensePlate,
}

export const vehicleRegisterTypeValues: { [id: number]: string } = {
  0: 'VIN',
  1: 'REPUVE',
  2: 'Placas',
};

export namespace VehicleRegisterType {
  export function items() {
    var items = Object.keys(VehicleRegisterType)
      .filter((type) => isNaN(<any>type) && type !== 'values')
      .map((key, index) => {
        let value = index;

        return { key: vehicleRegisterTypeValues[value], value: value };
      });

    // return items.filter((x) => x.key != undefined);
    return items.filter((x) => x.key != undefined && x.value == 0);
  }
}
